import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import useEventListener from './eventListener';

interface Size {
  width: number;
  height: number;
}
export function useElementSize<T extends HTMLElement = HTMLDivElement>(): [
  React.RefObject<T>,
  Size,
] {
  const ref = useRef<T>(null);

  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  const handleSize = useCallback(() => {
    if (ref.current == null) return;

    setSize({
      width: ref.current.offsetWidth || 0,
      height: ref.current.offsetHeight || 0,
    });
  }, [setSize]);

  useEventListener('resize', handleSize, undefined, true);

  useLayoutEffect(() => {
    const timeoutId = setTimeout(() => {
      handleSize();
    }, 200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [handleSize]);

  return [ref, size];
}
